import { useContext } from 'react'
import styled from 'styled-components'
import { ExamSubject } from 'generated/graphql'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'

const AnswerCountingInfoMobile = () => {
  const { examGradingResultData } = useContext(
    PredictionOfPassedContainerContext,
  )

  const viewerMathData = examGradingResultData?.viewerResult.detail.find(
    (item) => {
      return item.subject === ExamSubject.MATH
    },
  )

  const viewerReasoningData = examGradingResultData?.viewerResult.detail.find(
    (item) => {
      return item.subject === ExamSubject.REASONING
    },
  )
  return (
    <StyledWrapper>
      <div className="top">
        <strong>채점 결과</strong>
        <p>*맞은 문항/푼 문항</p>
      </div>
      <div className="subject-answer-counting">
        <p className="subject-name">수리</p>
        <p className="counting-text">
          <span>{viewerMathData?.correctCount}</span>/
          {viewerMathData?.answeredCount} 문항
        </p>
      </div>
      <div className="subject-answer-counting">
        <p className="subject-name">추리</p>
        <p className="counting-text">
          <span>{viewerReasoningData?.correctCount}</span>/
          {viewerReasoningData?.answeredCount} 문항
        </p>
      </div>
      <hr />
      <div className="all-counting-box">
        <label>전체</label>
        <p>
          <span>{examGradingResultData?.viewerResult.correctCount}</span>/
          {examGradingResultData?.viewerResult.answeredCount}
          문항
        </p>
      </div>
    </StyledWrapper>
  )
}

export default AnswerCountingInfoMobile

const StyledWrapper = styled.div`
  width: 100%;
  > .top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    > strong {
      font-size: 18px;
      font-weight: bold;
      line-height: 1.33;
      letter-spacing: -0.72px;
      text-align: left;
      color: #333;
    }

    > p {
      font-size: 12px;
      font-weight: normal;
      letter-spacing: -0.48px;
      text-align: left;
      color: ${({ theme }) => theme.color.text_3};
    }
  }

  > .subject-answer-counting {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    > .subject-name {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: -0.64px;
      color: #333;
    }

    > .counting-text {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: -0.64px;
      color: #333;

      > span {
        font-weight: bold;
      }
    }
  }

  > hr {
    width: 100%;
    height: 1px;
    background-color: #333;
    margin: 0px;
  }

  > .all-counting-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    background-color: #f9f9f9;
    margin-top: 12px;

    > label {
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      letter-spacing: -0.64px;
      text-align: left;
      color: #333;
    }

    > p {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.64px;
      color: #333;

      > span {
        font-weight: bold;
        color: #004eff;
      }
    }
  }
`
